/*
 * CM · Barra de regalo en el carrito
 *
 * Solo pinta el avance hacia el regalo (Mini Bag). No agrega, no quita ni cambia
 * nada del carrito: el regalo lo pone otra vía (app o promoción).
 *
 * Las líneas de la variante de regalo no cuentan para el acumulado, así el regalo
 * nunca se «paga» la meta a sí mismo.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('cm-gift-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var threshold = Number(config.threshold) || 0;
  var variantId = Number(config.variantId) || 0;
  var texts = config.texts || {};
  var giftName = escapeHtml(config.name || '');
  var lastCart = null;

  if (!threshold) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    return '$' + Math.max(0, Math.round(cents / 100)).toLocaleString('es-CL');
  }

  function template(text, values) {
    return escapeHtml(text || '').replace(/\|\|(\w+)\|\|/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function eligibleTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return item.variant_id === variantId ? total : total + item.final_line_price;
    }, 0);
  }

  function render(cart) {
    var bars = document.querySelectorAll('#cart-drawer [data-cm-gift]');
    var total = eligibleTotal(cart);
    var unlocked = total >= threshold;
    var percent = Math.min(100, Math.round((total / threshold) * 100));

    bars.forEach(function (bar) {
      var title = bar.querySelector('[data-cm-gift-title]');
      var fill = bar.querySelector('[data-cm-gift-fill]');
      var track = bar.querySelector('[data-cm-gift-track]');
      var meta = bar.querySelector('[data-cm-gift-meta]');
      var badge = bar.querySelector('[data-cm-gift-badge]');

      bar.classList.toggle('is-hidden', total === 0);
      bar.classList.toggle('is-unlocked', unlocked);

      if (title) {
        title.innerHTML = unlocked
          ? template(texts.unlocked, {gift: giftName})
          : template(texts.progress, {gift: giftName, amount: '<strong>' + formatMoney(threshold - total) + '</strong>'});
      }

      if (fill) fill.style.width = percent + '%';
      if (track) track.setAttribute('aria-valuenow', percent);

      if (meta) {
        meta.innerHTML = unlocked
          ? '<strong>' + giftName + '</strong> · ' + escapeHtml(texts.note)
          : '<strong>' + formatMoney(total) + '</strong> ' + escapeHtml(texts.accumulated);
      }

      if (badge) {
        badge.textContent = unlocked ? texts.free || '' : (texts.goal || '') + ' ' + formatMoney(threshold);
      }
    });
  }

  // Solo lee el carrito (GET /cart.js); nunca escribe
  function update() {
    fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        lastCart = cart;
        render(cart);
      })
      .catch(function (error) {
        console.warn('[cm-gift]', error);
      });
  }

  // El tema dispara theme:cart:added cada vez que redibuja el carrito (agregar, cambiar, quitar)
  document.addEventListener('theme:cart:added', update);

  // Al abrir el cajón por primera vez se pinta desde el template: se actualiza con el carrito real
  document.addEventListener('theme:cart:loaded', function () {
    if (lastCart) render(lastCart);
    update();
  });
})();
